"use client";

import { getImageProps } from "next/image";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { HomeTestimonial } from "@/types/home-messages";

// Keep initials working with older locale overlays that predate the optional fields.
const contributorInitials: Record<string, string> = {
  DroneTriageSolutions: "DT",
  "Dronespray Minnesota": "DM",
  "Ramon - Mining mapping": "R",
};

export default function TestimonialAttribution({
  attribution,
  initials,
  imageSrc,
  imageAlt,
  imageKind,
}: Pick<HomeTestimonial, "attribution" | "initials" | "imageSrc" | "imageAlt" | "imageKind">) {
  const isHeadshot = imageKind === "headshot";
  const imageProps = imageSrc?.startsWith("/") && !imageSrc.startsWith("//")
    ? getImageProps({ src: imageSrc, alt: imageAlt ?? "", width: 48, height: 48 }).props
    : { src: imageSrc, alt: imageAlt ?? "", width: 48, height: 48 };

  return (
    <div className="flex items-center gap-3">
      <Avatar
        className={`size-12 ${isHeadshot ? "rounded-full" : "rounded-none"}`}
        data-testimonial-image-slot
      >
        {imageSrc ? (
          <AvatarImage
            {...imageProps}
            className={isHeadshot ? "object-cover" : "object-contain"}
          />
        ) : null}
        <AvatarFallback
          aria-hidden="true"
          className="bg-[#EEF4F9] text-base font-semibold text-[#0A2B47]"
        >
          {initials ?? contributorInitials[attribution] ?? attribution.charAt(0)}
        </AvatarFallback>
      </Avatar>
      <p className="min-w-0 text-[16px] font-bold leading-normal text-[#0A2B47] [overflow-wrap:anywhere]">
        {attribution}
      </p>
    </div>
  );
}
